import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { Globe, ShieldCheck, Clock } from 'lucide-react';
export function PricingSection() {
  return <Section className="bg-partyPink-light relative overflow-hidden" data-id="element-151">
      {/* Background Confetti */}
      <div className="absolute inset-0 opacity-30 pointer-events-none" data-id="element-152">
        {[...Array(20)].map((_, i) => <div key={i} className={`absolute w-3 h-3 rounded-full ${i % 2 === 0 ? 'bg-mint-dark' : i % 3 === 0 ? 'bg-coral' : 'bg-yellow-400'}`} style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        transform: `scale(${Math.random() + 0.5})`
      }} data-id="element-153" />)}
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-[3rem] p-8 md:p-12 shadow-xl border-8 border-white relative z-10 text-center" data-id="element-154">
        <div className="mb-6" data-id="element-155">
          <h2 className="text-2xl md:text-3xl font-black text-partyPink-hot uppercase tracking-widest mb-2" data-id="element-156">
            Todo el Kit Fiesta Mágica
          </h2>
          <div className="inline-block bg-yellow-party text-gray-800 font-bold px-4 py-1 rounded-full text-lg transform rotate-2" data-id="element-157">
            + 10 BONOS EXCLUSIVOS
          </div>
        </div>

        {/* Mockup Image */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-lg" data-id="element-158">
          <img src="https://cdn.magicpatterns.com/uploads/6xCfR4aVRm3Su9KNjJRJ2Y/Mockup.png" alt="Kit Fiesta Mágica - +1000 Diseños, Imprimir, Recortar, Decorar" className="w-full h-auto object-cover" data-id="element-159" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-6 text-mint-dark font-script text-2xl md:text-3xl" data-id="element-160">
          <Globe className="w-8 h-8" data-id="element-161" />
          <span data-id="element-162">Paga en tu moneda local</span>
        </div>

        <motion.div animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="mb-6" data-id="element-163">
          <h3 className="text-5xl md:text-7xl font-black text-coral uppercase leading-none drop-shadow-sm" data-id="element-164">
            ¡Solo Hoy
            <br data-id="element-165" />
            60% OFF!
          </h3>
        </motion.div>

        <div className="flex justify-center mb-6" data-id="element-166">
          <div className="bg-partyPink-hot text-white font-bold px-6 py-2 rounded-lg text-xl uppercase tracking-wider shadow-md transform -rotate-2" data-id="element-167">
            Descarga Inmediata
          </div>
        </div>

        <div className="mb-8" data-id="element-168">
          <div className="flex justify-center items-end gap-4" data-id="element-169">
            <span className="text-3xl text-gray-400 line-through font-bold" data-id="element-170">
              17,99€
            </span>
            <span className="text-6xl font-black text-gray-800" data-id="element-171">6,99€</span>
          </div>
        </div>

        <Button size="lg" className="w-full md:w-auto text-xl py-6 px-12 animate-pulse hover:animate-none shadow-glow" data-id="element-172">
          ¡SÍ, QUIERO MI KIT AHORA!
        </Button>

        <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-173">
          <div className="flex items-center gap-2" data-id="element-174">
            <ShieldCheck className="w-5 h-5 text-mint-dark" data-id="element-175" />
            <span data-id="element-176">Pago 100% Seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-177">
            <Clock className="w-5 h-5 text-mint-dark" data-id="element-178" />
            <span data-id="element-179">Acceso de por vida</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-180">
            <ShieldCheck className="w-5 h-5 text-mint-dark" data-id="element-181" />
            <span data-id="element-182">Garantía de 7 días sin preguntas</span>
          </div>
        </div>
      </div>
    </Section>;
}